import { PriceAvailabilityResponse } from 'services/priceAvailability/types';
import { PartDetailsAndSchematicResponse } from 'types/product-diagram';

export const getPrice = (
  partDetailsAndSchematicResponse: PartDetailsAndSchematicResponse[],
  priceData: PriceAvailabilityResponse
) => {
  const updatedData = partDetailsAndSchematicResponse.map((diagramItem) => {
    const partsItems = diagramItem.lineItems.map((item) => ({
      ...item,
      quantity: item.quantity.trim().length === 0 ? '1' : item.quantity,
      partNumber: `${item.partNumber?.slice(0, -4)}-${item.partNumber?.slice(-4)}`
    }));

    const priceAndDetail = partsItems.map((lineItem) => {
      const priceAndAvailabilityData = priceData.items.find(
        (price) => price.partNumber === lineItem.partNumber
      );

      return priceAndAvailabilityData
        ? { ...lineItem, priceAndAvailabilityData }
        : lineItem;
    });

    return {
      ...diagramItem,
      graphicControlNumber: diagramItem.graphicControlNumber,
      currency: priceData.currency,
      lineItems: priceAndDetail,
      title: diagramItem.title
    };
  });
  return updatedData;
};
